module.exports = __webpack_public_path__ + "static/media/contact-logo.03ce5d8c.png";